import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import map from 'lodash/map';

import {
  getAppointments,
} from '../../actions';
import { t } from '../../../../../modules/infra/i18n';
import {
  getDate,
  filteredAppointmentsWithShop,
} from '../../appointmentSelector';
import { getStartOfDay } from '../../../../common/helpers/times';
import AppointmentsWrapper from '../../appointmentsWrapper';
import CalendarWidget from './combinedCalendarWidget';
import config from '../../../../../config';
import { USER_TYPES } from '../../../../auth/constants';
import getStatusNameAndClass from '../getStatusNameAndClass';

class CombinedView extends Component {

  componentWillMount() {
    this.fetch();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentDate !== this.props.currentDate && nextProps.currentDate) {
      this.fetch({
        currentDate: nextProps.currentDate,
      });
    }
  }

  fetch = (params) => {
    const {
      getAppointments,
      shop,
      timezone,
      currentDate,
      currentView,
      user,
      barberUser,
    } = {
      ...this.props,
      ...params,
    };

    const filters = {};
    switch (currentView) {
      case 'agendaDay':
        filters.dateTime__gte = getStartOfDay(timezone, currentDate).toJSON();
        filters.dateTime__lte = getStartOfDay(timezone, currentDate).endOf('day').toJSON();
        break;
      case 'agendaWeek':
        filters.dateTime__gte = getStartOfDay(timezone, currentDate).startOf('week').toJSON();
        filters.dateTime__lte = getStartOfDay(timezone, currentDate).endOf('week').toJSON();
        break;
      case 'month':
        filters.dateTime__gte = getStartOfDay(timezone, currentDate).startOf('month').toJSON();
        filters.dateTime__lte = getStartOfDay(timezone, currentDate).endOf('month').toJSON();
        break;
      default:
    }

    switch (user.kind) {
      case USER_TYPES.shop:
        getAppointments(shop, filters);
        break;
      case USER_TYPES.barber:
        filters.barberId = barberUser.id;
        getAppointments(barberUser.shopId, filters);
        break;
    }

  }

  render() {
    const {
      appointments,
      currentView,
      currentDate,
      timezone,
    } = this.props;

    const mobileList = map(appointments, (appointment, index) => {
      const status = getStatusNameAndClass(appointment);

      return (
        <div className="c-appointments-item" key={index}>
          <a className="c-appointment-details">
            <div className="c-appointment-details__col">
              <div className="c-round-number">01</div>
            </div>
            <div className="c-appointment-details__col c-appointment-details__col--small">
              <span className="large-and-up-p--">
                {moment(appointment.start).tz(timezone).format(config.timeFormat)} -
              {moment(appointment.end).tz(timezone).format(config.timeFormat)}
              </span>
            </div>
            <div className="c-appointment-details__col">
              {appointment.customerFullName}
            </div>
            <div className="c-appointment-details__col u-mt-- large-and-up-mt0">
              {appointment.description}
              <small>{t('appointment:combined_view.by')} <b>{appointment.barberFullName}</b></small>
            </div>
            <div className="c-appointment-details__col c-appointment-details__col--status">
              <div className={`c-status ${status.statusClass}`}>{status.statusName}</div>
            </div>
          </a>
        </div>
      );
    });

    return (
      <AppointmentsWrapper
        currentView={currentView}
        appointmentsLength={appointments.length}
      >
        <div>
          <div className="u-visible-for-medium-and-up">
            <CalendarWidget
              display-if={currentDate}
              appointments={appointments}
              currentDate={currentDate}
              currentView={currentView}
            />
          </div>
          <div className="u-visible-for-small">
            {appointments.length ? mobileList : <h4 className="u-text-center">{t('appointment:combined_view.no_appointments')}</h4>}
          </div>
        </div>
      </AppointmentsWrapper>
    );
  }
}

CombinedView.propTypes = {
  currentView: PropTypes.string.isRequired,
  currentDate: PropTypes.string.isRequired,
  appointments: PropTypes.arrayOf(PropTypes.object).isRequired,
  timezone: PropTypes.string.isRequired,
  getAppointments: PropTypes.func.isRequired,
  shop: PropTypes.string,
  user: PropTypes.object,
  barberUser: PropTypes.object,
};

const mapStateToProps = state => ({
  currentDate: getDate(state),
  appointments: filteredAppointmentsWithShop(state),
  timezone: state.auth.timezone,
  shop: state.auth.shop,
  user: state.auth.user,
  barberUser: state.auth.barberUser,
});

const mapDispatchToProps = {
  getAppointments,
};

export default connect(mapStateToProps, mapDispatchToProps)(CombinedView);
